import React, { useEffect, useState } from 'react';

import { LOCALSTORAGE_KEYS } from '@/constants';
import Minicart from '@/components/mini-cart';
import { CART_MAXIMUM } from '@/components/mini-cart/constants';
import { type Dispatch } from '@/app-state/store';
import { type VehicleSearchResult } from '@tac/vehicle-api-client/types';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicleIds' implicitly has an 'any' type.
const addVehicleIdsToLocalStorage = (vehicleIds) => {
  if (vehicleIds && vehicleIds.length) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem(LOCALSTORAGE_KEYS.COMPARE, JSON.stringify(vehicleIds));
      } catch (e) {
        // localStorage is disabled
        console.error('Failed to add vehicle ID to local storage', e);
      }
    }
  }
};

type MiniCartWrapperProps = {
  compareVehicleIds: string[];
  isOpen?: boolean;
  onClose: () => void;
  removeFromCompare: Dispatch['compare']['removeFromCompare'];
};

const MiniCartWrapper = ({
  compareVehicleIds = [],
  isOpen = false,
  onClose,
  removeFromCompare,
}: MiniCartWrapperProps) => {
  const compareVehicleCount = compareVehicleIds.length;
  const [VehicleData, setVehicleData] = useState<VehicleSearchResult[]>([]);

  useEffect(() => {
    let isSubscribed = true;

    addVehicleIdsToLocalStorage(compareVehicleIds);

    if (compareVehicleIds) {
      const getCarData = async () => {
        const vehicles = await fetch(`/api/get-vehicles?vehicleIds=${compareVehicleIds.join(',')}`).then((r) =>
          r.json()
        );
        if (isSubscribed && typeof vehicles !== 'string') {
          setVehicleData(vehicles);
        }
      };
      getCarData();
    }

    return () => {
      isSubscribed = false;
    };
  }, [compareVehicleIds]);

  const vehicles = compareVehicleIds ? VehicleData : [];

  let alertMessage = '';
  if (compareVehicleCount === 1) {
    alertMessage = "There aren't enough cars in your list to compare. Select one more.";
  } else if (compareVehicleCount > CART_MAXIMUM) {
    alertMessage = 'Too many vehicles to compare. The maximum number of vehicles is 6.';
  }

  return (
    <Minicart
      {...{
        isOpen,
        removeFromCompare,
        vehicles,
        vehicleIds: compareVehicleIds,
        compareVehicleCount,
        onClose,
        alertMessage,
      }}
    />
  );
};

export default MiniCartWrapper;
